module.exports = __webpack_public_path__ + "img/RDS_NEXT.7668db62.png";